import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Content } from "../../models/content";
import { Player } from "../../models/player";

@Component({
  selector: 'app-players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.scss']
})
export class PlayersComponent implements OnInit {

  @Input()
  content: Content;

  @Output() contentChangeEvent = new EventEmitter<void>();

  @Input()
  players: Player[];
  allPlayers: boolean;
  selectedPlayers: number[];

  @Input()
  primaryColor: string;
  @Input()
  secondaryColor: string;

  constructor() {
    this.selectedPlayers = [];
  }

  ngOnInit() {
    if(this.content.players && this.content.players.length > 0){
      this.selectedPlayers = this.content.players;
      this.contentChangeEvent.emit();
    }
  }

  setAllPlayers(){
    if(this.allPlayers){
      this.allPlayers = false;
    } else{
      this.allPlayers = true;
    }
    this.content.allPlayers = this.allPlayers;
    this.content.players = [];
    this.selectedPlayers = [];
    for(var i in this.players){
      this.selectedPlayers.push(this.players[i].getPlayerID());
    }
    this.content.players = this.selectedPlayers;
    this.contentChangeEvent.emit();
  }

  isAllPlayersSelected(){
    if(this.content.allPlayers){
      return this.content.allPlayers;
    }
    return false;
  }

  selectPlayer(player: Player){
    var i = this.selectedPlayers.findIndex(plid => plid == player.getPlayerID());
    if(i > -1) {
      this.selectedPlayers.splice(i,1);
    } else{
      this.selectedPlayers.push(player.getPlayerID());
    }
    this.content.players = this.selectedPlayers;
    this.content.allPlayers = false;
    this.contentChangeEvent.emit();
  }

  isPlayerSelected(player: Player){
    var i = this.selectedPlayers.findIndex(pid => pid == player.getPlayerID());
    return i > -1;
  }

  getCheckColor(): string{
    return this.isAllPlayersSelected() ? this.secondaryColor : '#ffffff';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/players/players.component.ts